import { useContext } from 'react';
import { BannerContext } from '../providers/upgradeBanner';

export default function useBannerContext() {
  return useContext(BannerContext);
}
